<template>
  <div class="agentic-sidebar" :style="{ left: sidebarLeftPosition + 'px' }">
    <div class="sidebar-content">
      <div class="sidebar-top">
        <div class="sidebar-section">
          <router-link
            :to="`/${tenantPrefix}/agentic-dashboard`"
            class="sidebar-item"
            :class="{ active: $route.name === 'AgenticDashboard' && !$route.params.dashboardId }"
          >
            <div class="sidebar-item-icon">
              <img :src="homeIcon" alt="Home" />
            </div>
            <span class="sidebar-item-text">Home</span>
          </router-link>
          
          <div class="sidebar-divider"></div>
          
          <router-link
            :to="`/${tenantPrefix}/agentic-dashboard/all`"
            class="sidebar-item"
            :class="{ active: $route.name === 'AgenticDashboardAll' }"
          >
            <div class="sidebar-item-icon">
              <img :src="allDashboardIcon" alt="All dashboard" />
            </div>
            <span class="sidebar-item-text">All dashboard</span>
          </router-link>
          
          <div class="sidebar-divider"></div>
          
          <router-link
            :to="`/${tenantPrefix}/agentic-dashboard/starred`"
            class="sidebar-item"
            :class="{ active: $route.name === 'AgenticDashboardStarred' }"
          >
            <div class="sidebar-item-icon">
              <img :src="starIcon" alt="Starred" />
            </div>
            <span class="sidebar-item-text">Starred</span>
          </router-link>
          
          <div class="sidebar-divider"></div>
          
          <router-link
            :to="`/${tenantPrefix}/agentic-dashboard/shared`"
            class="sidebar-item"
            :class="{ active: $route.name === 'AgenticDashboardShared' }"
          >
            <div class="sidebar-item-icon">
              <img :src="sharedIcon" alt="Shared with me" />
            </div>
            <span class="sidebar-item-text">Shared with me</span>
          </router-link>
        </div>
      </div>
      
      <!-- Charts List Section (only show on dashboard view) -->
      <div v-if="showChartsList && charts && charts.length > 0" class="sidebar-charts-section">
        <div class="sidebar-section-title">Plots</div>
        <div class="sidebar-charts-list">
          <div
            v-for="(chart, index) in charts"
            :key="index"
            v-if="chart"
            class="sidebar-chart-item"
            :class="{ 'selected': selectedChartIndex === index }"
            @click.stop="handleChartSelect(index)"
          >
            <div class="sidebar-chart-icon">
              <img :src="chartIcon" alt="Chart" />
            </div>
            <span class="sidebar-chart-text">{{ chart.title || `Plot ${index + 1}` }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTenantPrefix } from "@/utils/tenant";

export default {
  name: "AgenticSidebar",
  props: {
    sidebarOffset: {
      type: Number,
      default: 72,
    },
    charts: {
      type: Array,
      default: () => [],
    },
    selectedChartIndex: {
      type: Number,
      default: null,
    },
    showChartsList: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      homeIcon: require("@/assets/Images/Dashboard/home.svg"),
      allDashboardIcon: require("@/assets/Images/Dashboard/element-plus.svg"),
      starIcon: require("@/assets/Images/Dashboard/star.svg"),
      sharedIcon: require("@/assets/Images/Dashboard/profile-2user.svg"),
      chartIcon: require("@/assets/Images/Dashboard/element-plus.svg"), // Chart icon
    };
  },
  methods: {
    handleChartSelect(index) {
      this.$emit("chart-selected", index);
    },
  },
  computed: {
    tenantPrefix() {
      return getTenantPrefix();
    },
    sidebarLeftPosition() {
      return this.sidebarOffset;
    },
  },
};
</script>

